// extracted by mini-css-extract-plugin
module.exports =  {"badge":"FixedIncomeLogo-module__badge--lVI4a"};